import type { SiteControllerSettingAirHostBaseInfoInput } from "@/lib/gql/__generated__/graphql";

import type { SiteControllerSettingAirHostFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingAirHostFormModel["ViewModel"];
};
export const viewModelToInput = ({ viewModel }: Props) => {
	const { hotelID, airHostSettings } = viewModel;

	const input: SiteControllerSettingAirHostBaseInfoInput = {
		hotelID,
		airHostSettings: {
			airHostAPIAccessToken: airHostSettings.airHostAPIAccessToken.value,
			airHostPartnerID: airHostSettings.airHostPartnerID.value,
			airHostPropertyID: airHostSettings.airHostPropertyID.value,
			chillnnRoomAndAirHostPricePlanMappings: airHostSettings.chillnnRoomAndAirHostPricePlanMappings.value.map(
				(mapping) => ({
					chillnnRoomID: mapping.chillnnRoomID.value,
					airHostPlanID: mapping.airHostPlanID.value,
					airHostRoomTypeID: mapping.airHostRoomTypeID.value,
					airHostRoomCheckInTime: mapping.airHostRoomCheckInTime.value,
					airHostRoomCheckOutTime: mapping.airHostRoomCheckOutTime.value,
				}),
			),
		},
	} satisfies SiteControllerSettingAirHostBaseInfoInput;

	return input;
};
